import { getGclid } from '../../helpers/gclid.js';

export default class AjaxForm {

    constructor(element = null) {
        this.element = element;
        this.config = JSON.parse(this.element.dataset.ajaxForm);

        // We have seen a large number of spam submissions by simple bots.
        // An easy fix is to set the url and display the banner via JavaScript
        // as many simple bots do not execute JavaScript.
        this.element.setAttribute('hx-post', this.config.url);
        window.htmx.process(this.element);

        if (this.element.csrf_token && this.config.csrf) {
            this.element.csrf_token.value = this.config.csrf;
        }

        if (this.element.gclid) {
            this.element.gclid.value = getGclid();
        }

        this.element.addEventListener('submit', this.onSubmit);
    }

    onSubmit(event) {
        event.submitter.disabled = true;

        if (event.submitter.classList.contains('c-button')) {
            event.submitter.classList.add('c-button--loading');
        }
    }

}
